Highcharts.setOptions({
  lang: {
    viewFullscreen: 'Посмотреть в полноэкранном режиме',
    printChart: 'Распечатать',
    downloadPNG: 'Скачать PNG',
    downloadJPEG: 'Скачать JPEG',
    downloadSVG: 'Скачать SVG'
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: [
          'viewFullscreen',
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadSVG',
        ]
      }
    },
  },
});

